import { render, staticRenderFns } from "./ResetConfirmation.vue?vue&type=template&id=52282002&scoped=true&"
import script from "./ResetConfirmation.vue?vue&type=script&lang=js&"
export * from "./ResetConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52282002",
  null
  
)

export default component.exports